.input-container {
    display: flex;
    flex-direction: column;
}

.input-container--two-columns {
    composes: input-container;
    flex-wrap: wrap;
    height: 302px; /* Looks great. */
    width: 816px; /* 400px each column, 16px gap */
}

.input-container--two-columns > div {
    margin-right: 16px;
    width: 400px;
}

/* No two column */
@media (max-width: 1344px) {
    .input-container--two-columns {
        flex-wrap: unset;
        height: unset;
        width: unset;
    }

    .input-container--two-columns > div {
        margin-right: unset;
        width: unset;
    }
}
